import React from 'react';

const Footer = () => {
    return(
        <footer className='black-80 sans-serif lh-solid mt4 mb4'>
        <p className='f6 '>
            <span> Made with ♥ by <a 
            className='link hover-blue hover-bb pointer' 
            href='https://github.com/melipi'>melipi</a>
            </span>
        </p>
    </footer>
    )
}

export default Footer;